import { render, staticRenderFns } from "./pcb_ban_size.vue?vue&type=template&id=4fa6928f&scoped=true"
import script from "./pcb_ban_size.vue?vue&type=script&lang=js"
export * from "./pcb_ban_size.vue?vue&type=script&lang=js"
import style0 from "./pcb_ban_size.vue?vue&type=style&index=0&id=4fa6928f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa6928f",
  null
  
)

export default component.exports